/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { SafeAny } from '@pf/shared-common';
import { PFWmsEntities } from '@pf/shared-common';
import {
    PutAwayCreate,
    PutAwayDto,
    PutAwayRead,
    PutAwaySearchParams,
} from '../entities/put-away.dto';
import { PutAwayDataService } from '../infrastructure/put-away-lists/put-away.data.service';
import { PutAwayStore } from '../infrastructure/put-away-lists/put-away.store';
import { PutAwayMapper } from '../infrastructure/put-away-lists/put-away.mapper';

@Injectable()
export class PutAwayFacade extends AbstractManageEntityFacade<
    PutAwayDto,
    PutAwayRead,
    PutAwayCreate,
    PutAwaySearchParams
> {
    nameField: keyof PutAwayDto = 'id';

    constructor(
        dataService: PutAwayDataService,
        store: PutAwayStore,
        mapper: PutAwayMapper
    ) {
        super(dataService, null, store, mapper);
        this.listenForRealTimeEvents(PFWmsEntities.PutAway);
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField as SafeAny
    );

    protected override getParentId(dto: PutAwayDto): string | undefined {
        return dto.putAwayListId;
    }

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof PutAwayDto, string>> {
        return { putAwayListId: searchText };
    }
}
